const DateTimeFormat = {
    Date: "DD MMM YYYY",
    DateTime: "DD MMM YYYY HH:mm",
    Backend: 'YYYY-MM-DDTHH:mm:ssZ',
    BackendDate: 'YYYY-MM-DDT00:00:00Z',
    BackendDateTime: 'YYYY-MM-DDTHH:mm:ssZ',
}

export default DateTimeFormat;